export default "__VITE_ASSET__45424816__"